<script>
    export let patientName = ""

    let today = new Date();
    let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

    let displayDate = date + " | " + time;
    setInterval(() => {
        let today = new Date();

        let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        displayDate = date + " | " + time;
    },1000)

    function random(max) {
        return 30 + Math.floor(Math.random() * Math.floor(max));
    }

    let displayVo2 = random(30, 60)
    setInterval(() => {
        displayVo2 = random(30, 60)
    },800)
</script>

<div class="top-bar">
    <p>Patient: {patientName}</p>
    <p>{displayDate}</p>
    <p>VO2: {displayVo2}mL/kg/min</p>
    <p>Classification: CG6</p>
</div>

<style>
    .top-bar {
        width:100%;
        display:grid;
        height: 40px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    .top-bar > p {
        color:white;
        font-size: 1.1rem;
        margin: auto auto;
    }
</style>